<script setup lang="ts">
import { useAppTextsStore } from '~/stores/appTexts'

const appTexts = useAppTextsStore()
await appTexts.fetchAppTexts()
</script>

<template>
	<div id="pdf-big-layout">
		<slot />
	</div>
</template>

<style scoped>
@page {
	margin: 25mm 0mm !important;
}
@page:first {
	margin-top: 0mm !important;
	margin-bottom: 0mm !important;
}
</style>
